module.exports = __webpack_public_path__ + "uia-schedule-now.020956a74461e3fc91351d10ff5e327c.svg";